export default {
    options: {
        readMore: {
            initHeight: 100,
            maskedClass: 'mask-content'
        }
    },

    init: function() {
        const self = this;

        if( document.querySelector('.emc-add-to-quote') === null ) {
            return;
        }

        self.initListeners();

        if( self.shouldEnableDescriptionMask() ) {
            self.enableDescriptionMask();
        }
    },

    initListeners: function() {
        const self = this;

        document.querySelectorAll('.emc-add-to-quote').forEach(elem => {
            elem.addEventListener( 'click', (e) => self.showProductOptionModal(e) );
        })

        document.getElementById('grouped-product-modal-close').addEventListener( 'click', e => self.closeModal(e) );
    }, 

    showProductOptionModal: function(e) {
        const prodId = e.target.id.replace('add-to-quote-', '');

        document.querySelectorAll( '.product-options-container' ).forEach( elem => {
            if( elem.id === 'container-product-' + prodId ) {
                elem.classList.add('active');
                elem.querySelector('.pofw-product-options-wrapper').classList.add('active');
            } else {
                elem.classList.remove('active');
                elem.querySelector('.pofw-product-options-wrapper').classList.remove('active');
            }
        })


        document.getElementById('grouped-product-options-modal').classList.remove("hidden");

    },

    closeModal: function(e) {
        document.getElementById('grouped-product-options-modal').classList.add("hidden");
    },

    shouldEnableDescriptionMask: function() {
        const self = this;
        const descContainer = document.querySelector('.product-long-desc');

        if( descContainer ) {
            if( descContainer.offsetHeight > self.options.readMore.initHeight   ) {
                return true;
            }
        }

        return false;
    },

    enableDescriptionMask: function() {
        const self = this;
        const descContainer = document.querySelector('.product-long-desc');

        if( !descContainer ) {
            return;
        }

        descContainer.classList.add(self.options.readMore.maskedClass);
        descContainer.classList.add('enabled');

        const btn = document.createElement('button');
        const icon = document.createElement('i');

        btn.classList.add('mask-content-toggle', 'font-bold', 'text-grey-dark', 'outline-none', 'focus:outline-none' )
        icon.classList.add('fal', 'fa-chevron-down', 'ml-2', 'text-primary');

        btn.innerHTML = descContainer.dataset.revealText;

        btn.appendChild(icon);
        descContainer.parentElement.appendChild(btn);

        btn.addEventListener('click', function() {
            descContainer.classList.toggle('enabled')
        })

    }
}